import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
    title?: string;
    isFullHeight?: boolean;
    justifyContent?: "justify-center" | "justify-start" | "justify-end";
    alignItems?: "items-center" | "items-start" | "items-end";
    className?: string;
}

const PageContainer: React.FC<Props> = (props) => {
    const {
        children,
        isFullHeight = false,
        alignItems = "items-center",
        justifyContent = "justify-center",
        className = "",
        title = 'DL NEWS CMS'
    } = props;

    return (
        <div
            className={clsx(
                alignItems,
                justifyContent,
                isFullHeight && "min-h-screen",
                "overflow-x-clip w-full flex flex-col px-2",
                className
            )}
        >
            <title>{title}</title>
            {children}
        </div>
    )
}

export default PageContainer